<template>
  <div>
    <div class="wrapper">
      <div class="container">
        <div class="avatar">
          <img
            src="https://cdn140.picsart.com/315451665199211.png?type=webp&to=min&r=480"
            alt
          />
        </div>
        <form class="form" @submit.prevent>
          <input
            type="text"
            placeholder="Tên đăng nhập"
            required
            v-model="storeUsernamePassword.uname"
          />
          <input
            type="password"
            placeholder="Mật khẩu"
            required
            v-model="storeUsernamePassword.pword"
          />
          <button type="submit" id="login-button" @click="submitLogin()">
            Đăng nhập
          </button>
        </form>
      </div>
      <ul class="bg-bubbles">
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Login",
  data() {
    return {
      storeUsernamePassword: {
        uname: "",
        pword: ""
      },
      storeSheetData: null
    };
  },

  methods: {
    submitLogin() {
      // sheet url to get username password in googlespeadsheet
      const sheet =
        "https://sheet.best/api/sheets/98958532-8ddf-478a-b977-9f68a6bf7d7b/tabs/Accounts/search?username=" +
        this.storeUsernamePassword.uname +
        "&password=" +
        this.storeUsernamePassword.pword;

      if (
        this.storeUsernamePassword.pword != "" &&
        this.storeUsernamePassword.uname
      ) {
        fetch(sheet)
          .then(response => response.json())
          .then(data => {
            // console.log(data);
            this.storeSheetData = data;
            if (this.storeSheetData.length == 0) {
              alert("Tên đăng nhập hoặc mật khẩu sai");
            } else {
              this.flag = true;
              const sessionId = this.storeSheetData[0].id;
              const sessionName = this.storeSheetData[0].name;
              const sessionUsername = this.storeSheetData[0].username;
              const sessionPassword = this.storeSheetData[0].password;
              const sessionRole = this.storeSheetData[0].role;
              const sessionGender = this.storeSheetData[0].gender;
              const sessionAddress = this.storeSheetData[0].address;
              const sessionPhone = this.storeSheetData[0].phone;
              const sessionFacebook = this.storeSheetData[0].facebook;
              const sessionCreated = this.storeSheetData[0].created;
              const sessionOwned = this.storeSheetData[0].owned;
              const sessionActive = this.storeSheetData[0].active;

              // write to session

              sessionStorage.setItem("id", sessionId);
              sessionStorage.setItem("name", sessionName);
              sessionStorage.setItem("username", sessionUsername);
              sessionStorage.setItem("password", sessionPassword);
              sessionStorage.setItem("role", sessionRole);
              sessionStorage.setItem("gender", sessionGender);
              sessionStorage.setItem("address", sessionAddress);
              sessionStorage.setItem("phone", sessionPhone);
              sessionStorage.setItem("facebook", sessionFacebook);
              sessionStorage.setItem("created", sessionCreated);
              sessionStorage.setItem("owned", sessionOwned);
              sessionStorage.setItem("active", sessionActive);

              // mặc định vào trang quản lý đơn
              // sessionStorage.setItem("action", 1);

              // điều hướng đến page
              if (sessionRole == "admin") {
                this.$router.push("/admin/neworder");
              } else if (sessionRole == "editor") {
                this.$router.push("/editor/neworder");
              } else if (sessionRole == "member") {
                this.$router.push("/member/neworder");
              } else {
                this.$router.push("/");
              }
            }
          })
          .catch(error => {
            console.error(error);
          });
      }
    }
  }
};
</script>

<style lang="css" scoped>
.avatar {
  width: 5rem;
  height: 5rem;
  position: relative;
  left: 50%;
  transform: translate(-50%, 0%);
  border-radius: 50%;
  overflow: hidden;
}
.avatar img {
  width: 100%;
  height: 100%;
}
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-weight: 300;
}
body {
  color: white;
  font-weight: 300;
}
body::-webkit-input-placeholder {
  color: white;
  font-weight: 300;
}
body:-moz-placeholder {
  color: white;
  opacity: 1;
  font-weight: 300;
}
body::-moz-placeholder {
  color: white;
  opacity: 1;
  font-weight: 300;
}
body:-ms-input-placeholder {
  color: white;
  font-weight: 300;
}
.wrapper {
  background: linear-gradient(to bottom right, #6bff95 0%, #00af75 100%);
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 100%;
  padding-top: 100px;
  top: 0;
  overflow: hidden;
}
.wrapper.form-success .container h1 {
  transform: translateY(85px);
}
.container {
  max-width: 600px;
  margin: 0 auto;
  padding: 80px 0;
  height: 400px;
  text-align: center;
}
.container h1 {
  font-size: 40px;
  transition-duration: 1s;
  transition-timing-function: ease-in-put;
  font-weight: 200;
}
form {
  padding: 20px 0;
  position: relative;
  z-index: 2;
}
form input {
  appearance: none;
  outline: 0;
  border: 1px solid rgba(255, 255, 255, 0.4);
  background-color: rgba(255, 255, 255, 0.2);
  width: 250px;
  border-radius: 3px;
  padding: 10px 15px;
  margin: 0 auto 10px auto;
  display: block;
  text-align: center;
  font-size: 18px;
  color: white;
  transition-duration: 0.25s;
  font-weight: 300;
}
form input:hover {
  background-color: rgba(255, 255, 255, 0.4);
}
form input:focus {
  background-color: white;
  width: 300px;
  color: #53e3a6;
}
form button {
  appearance: none;
  outline: 0;
  background-color: white;
  border: 0;
  padding: 10px 15px;
  color: #53e3a6;
  border-radius: 3px;
  width: 250px;
  cursor: pointer;
  font-size: 18px;
  transition-duration: 0.25s;
}
form button:hover {
  background-color: #f5f7f9;
}
.bg-bubbles {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
.bg-bubbles li {
  position: absolute;
  list-style: none;
  display: block;
  width: 40px;
  height: 40px;
  background-color: rgba(255, 255, 255, 0.15);
  bottom: -160px;
  -webkit-animation: square 25s infinite;
  animation: square 25s infinite;
  -webkit-transition-timing-function: linear;
  transition-timing-function: linear;
}
.bg-bubbles li:nth-child(1) {
  left: 10%;
}
.bg-bubbles li:nth-child(2) {
  left: 20%;
  width: 80px;
  height: 80px;
  animation-delay: 2s;
  animation-duration: 17s;
}
.bg-bubbles li:nth-child(3) {
  left: 25%;
  animation-delay: 4s;
}
.bg-bubbles li:nth-child(4) {
  left: 40%;
  width: 60px;
  height: 60px;
  animation-duration: 22s;
  background-color: rgba(255, 255, 255, 0.25);
}
.bg-bubbles li:nth-child(5) {
  left: 70%;
}
.bg-bubbles li:nth-child(6) {
  left: 80%;
  width: 120px;
  height: 120px;
  animation-delay: 3s;
  background-color: rgba(255, 255, 255, 0.2);
}
.bg-bubbles li:nth-child(7) {
  left: 32%;
  width: 160px;
  height: 160px;
  animation-delay: 7s;
}
.bg-bubbles li:nth-child(8) {
  left: 55%;
  width: 20px;
  height: 20px;
  animation-delay: 15s;
  animation-duration: 40s;
}
.bg-bubbles li:nth-child(9) {
  left: 25%;
  width: 10px;
  height: 10px;
  animation-delay: 2s;
  animation-duration: 40s;
  background-color: rgba(255, 255, 255, 0.3);
}
.bg-bubbles li:nth-child(10) {
  left: 90%;
  width: 160px;
  height: 160px;
  animation-delay: 11s;
}
@-webkit-keyframes square {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-700px) rotate(600deg);
  }
}
@keyframes square {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-700px) rotate(600deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue